import { useQueries } from "@tanstack/react-query";

import { agentQueryOptions } from "~/agent/data-source/agent-query-options";

export function useAgentDisplayNames(agentIds: (string | null | undefined)[]) {
  const ids = [...new Set(agentIds.filter((id): id is string => !!id))];
  return useQueries({
    queries: ids.map((id) => agentQueryOptions.byId(id)),
    combine: (results) =>
      Object.fromEntries(
        results.map((result, index) => [
          ids[index],
          {
            data: result.data?.displayName,
            error: result.error,
            isLoading: result.isLoading,
            isError: result.isError,
          },
        ]),
      ),
  });
}
